import _ from "lodash";
import React, { useMemo } from "react";
import classnames from "classnames";
import { FormattedMessage, useIntl } from "react-intl";

import NativeSelect from "../select/NativeSelect";
import { DEFAULT_PROFILE } from "../../store/profiles/fixedProfiles";

import "./ProfilePicker.scss";

export const ProfilePicker = ({
  tabs,
  onTabClick,
  className,
  activeTab: selectedProfileId,
  counter,
  sideSection,
  isUrlFiltersPage,
}) => {
  const intl = useIntl();
  const mappedTabs = useMemo(() => {
    return tabs.map((tab) => ({
      ...tab,
      value: tab.id,
      name:
        tab.type === "custom" ? tab.name : intl.formatMessage({ id: tab.type }),
    }));
  }, [tabs, intl]);
  const selectedTab = _.find(tabs, ({ id }) => id === selectedProfileId);
  const showDefaultDescription =
    isUrlFiltersPage && selectedTab.type === DEFAULT_PROFILE.type;

  return (
    <div className={classnames("profile-picker", className)}>
      <div className="profile-picker__header">
        <div className="profile-picker__controls">
          <div className={"profile-picker__label"}>
            {counter ? (
              counter
            ) : (
              <h2 className={"counter counter__label"}>
                <FormattedMessage id={"profiles"} />
              </h2>
            )}

            <NativeSelect
              className={"profile-picker__select"}
              options={mappedTabs}
              selected={selectedProfileId}
              onChange={onTabClick}
              toggleView="input"
              ariaLabelMessage="profiles"
            />
          </div>
          {sideSection && (
            <div className="profile-picker__side-section">{sideSection}</div>
          )}

          {showDefaultDescription && (
            <div className="profile-picker__description">
              <div className={"tab-description-message"}>
                <FormattedMessage id={`visitors_description`} />
              </div>
            </div>
          )}
        </div>
      </div>

      {selectedTab && (
        <div className="profile-picker__content">{selectedTab.content}</div>
      )}
    </div>
  );
};
